<template>
  <div class="hello">

  </div>
</template>

<script>
import AuthService from '@/services/AuthService'

export default {
  name: 'CallbackPage',
  created () {
    AuthService.handleAuthentication()
  },
  data () {
    return {
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/CallbackPage.vue